import { Box, BoxProps } from "@mui/material";
import { FC } from "react";
import { useMatch } from "react-router-dom";
import { MenuLessonCard } from "@/app2/pages/HomePage/Components/MenuLessonCard";
import type { CurriculumModuleDto } from "@/app2/shared/data";

interface IProps extends BoxProps {
	module: CurriculumModuleDto;
	courseSlug: string;
}

export const CourseCurriculumModule: FC<IProps> = ({
	className,
	module,
	courseSlug,
	...boxProps
}) => {
	const url = "/course/" + courseSlug + "/" + module.type + "/" + module.slug + "/*";
	const pageIsActive = useMatch(url);

	return (
		<Box
			marginBottom={"20px"}
			className={className}
			sx={{paddingRight: "14px"}}
		>
			<MenuLessonCard
				title={module.title}
				duration={module.duration ?? 0}
				imageUrl={module.videoThumbnailUrl ?? ""}
				completed={module.complete}
				isActive={!!pageIsActive}
				{...boxProps}
			/>
		</Box>
	);
};
